import { SxProp, View } from 'dripsy';
import React, { useState } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { ReplaceCardWebZeroScreen } from './ReplaceCardWebZero.screen';
import { ReplaceCardWebOneScreen } from './ReplaceCardWebOne.screen';
import { ReplaceCardWebTwoScreen } from './ReplaceCardWebTwo.screen';
import { ReplaceCardWebThreeScreen } from './ReplaceCardWebThree.screen';

export interface ReplaceCardProps {
  onClose: () => void;
}

export const ReplaceCardWebScreen: React.FC<ReplaceCardProps> = (props) => {
  const { onClose } = props;
  const { t } = useTranslation('account-management');
  const {} = sxStyles;
  const [step, setStep] = useState('zero');

  if (step == 'zero') return <ReplaceCardWebZeroScreen onClose={onClose} onStep={(step: string) => setStep(step)} />;
  else if (step == 'one') return <ReplaceCardWebOneScreen onClose={onClose} onStep={(step: string) => setStep(step)} />;
  else if (step == 'two') return <ReplaceCardWebTwoScreen onClose={onClose} onStep={(step: string) => setStep(step)} />;
  else if (step == 'three') return <ReplaceCardWebThreeScreen onClose={onClose} />;
  else return <View></View>;
};
const sxStyles: Record<string, SxProp> = {};
